<div class="report-filters-container">
  @if (isPdf) {
  <!-- PDF Filters Section -->
  <div class="pdf-filters-section">
    <div class="pdf-filter-item">
      <div class="flex-center-start">
        <app-icon name="calendar" color="#12DB88" [size]="16"></app-icon>
        <span class="pdf-filter-label">Rango de fechas:</span>
      </div>
      <span class="pdf-filter-value">{{ getDateRange() }}</span>
      <p class="pdf-filter-subtitle">{{ getDateRangeDescription() }}</p>
    </div>
    <div class="pdf-filter-item">
      <div class="flex-center-start">
        <app-icon name="filter" color="#12DB88" [size]="16"></app-icon>
        <span class="pdf-filter-label">Filtros adicionales:</span>
      </div>
      <div class="pdf-filter-values">
        <p class="pdf-filter-value-item">Compañía: {{ getCompanyFilter() }}</p>
        <p class="pdf-filter-value-item">Usuario: {{ getUserFilter() }}</p>
        <p class="pdf-filter-value-item">Cliente: {{ getClientFilter() }}</p>
      </div>
    </div>
  </div>
  } @else {
  <!-- Interactive Filters Section -->
  <div class="filters-section">
    <nz-row [nzGutter]="[16, 16]">
      <!-- Date Filters Column -->
      <nz-col nzSpan="12" *ngIf="showDateFilters">
        <nz-card class="filter-card"
          [ngClass]="{'temperature-mode': filterMode === 'temperature', 'operations-mode': filterMode === 'operations', 'crm-totals-mode': filterMode === 'crm-totals', 'finance-mode': filterMode === 'finance', 'crm-mode': filterMode === 'crm'}"
          [nzTitle]="customTitleTpl">
          <div class="filter-content">
            <nz-row [nzGutter]="16">
              <nz-col [nzSpan]="8">
                <div class="filter-field">
                  <label class="filter-label">Tipo</label>
                  <nz-select [(ngModel)]="dateType" (ngModelChange)="onDateFilterChange()" style="width: 100%">
                    <nz-option *ngFor="let option of dateTypeOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8">
                <div class="filter-field">
                  <label class="filter-label">Número</label>
                  <nz-select [(ngModel)]="dateNumber" (ngModelChange)="onDateFilterChange()" style="width: 100%">
                    <nz-option *ngFor="let option of numberOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8">
                <div class="filter-field">
                  <label class="filter-label">Período</label>
                  <nz-select [(ngModel)]="datePeriod" (ngModelChange)="onDateFilterChange()" style="width: 100%">
                    <nz-option *ngFor="let option of periodOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>
            <div style="height: 20px;"></div>
            <div class="date-range">
              <nz-date-picker [(ngModel)]="startDate" (ngModelChange)="emitFilterChange()"
                style="width: 100%"></nz-date-picker>
              <span class="date-separator">hasta</span>
              <nz-date-picker [(ngModel)]="endDate" (ngModelChange)="emitFilterChange()"
                style="width: 100%"></nz-date-picker>
            </div>
            <!-- Filtro de Fecha por solo para modo Operations -->
            @if (filterMode === 'operations') {
            <div style="height: 20px;"></div>
            <div class="filter-field">
              <label class="filter-label">Fecha por</label>
              <nz-select [(ngModel)]="selectedDateFilterType"
                (ngModelChange)="onOtherFilterChange('dateFilterType', $event, dateFilterTypeOptions)"
                [nzLoading]="loadingDateFilterType" nzPlaceHolder="Tipo de fecha" [nzAllowClear]="true"
                style="width: 100%;">
                <nz-option *ngFor="let option of dateFilterTypeOptions" [nzValue]="option.value"
                  [nzLabel]="option.label"></nz-option>
              </nz-select>
            </div>
            }
          </div>
        </nz-card>
        <ng-template #customTitleTpl>
          <div class="title-with-icon">
            <app-icon name="calendar" size="base"></app-icon>
            <span>Rango de fechas</span>
          </div>
        </ng-template>
      </nz-col>

      <!-- Additional Filters Column -->
      <nz-col nzSpan="12" *ngIf="showAdditionalFilters">
        <nz-card class="filter-card"
          [ngClass]="{'temperature-mode': filterMode === 'temperature', 'operations-mode': filterMode === 'operations', 'crm-totals-mode': filterMode === 'crm-totals', 'finance-mode': filterMode === 'finance', 'crm-mode': filterMode === 'crm'}"
          [nzTitle]="additionalFiltersTitleTpl">
          <div class="filter-content flex flex-column" style="gap:16px">
            @if (filterMode === 'projects') {
            <!-- Projects Mode Filters -->
            <nz-row [nzGutter]="16">
              <nz-col [nzSpan]="8">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedProjects"
                    (ngModelChange)="onOtherFilterChange('projects', $event, projectOptions)"
                    [nzLoading]="loadingProjects" nzPlaceHolder="Proyecto(s)" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of projectOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedMerchandise"
                    (ngModelChange)="onOtherFilterChange('merchandise', $event, merchandiseOptions)"
                    [nzLoading]="loadingMerchandise" nzPlaceHolder="Mercancía" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of merchandiseOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedStatus"
                    (ngModelChange)="onOtherFilterChange('status', $event, statusOptions)" [nzLoading]="loadingStatus"
                    nzPlaceHolder="Estado(s)" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of statusOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8" style="margin-top: 16px;">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedMBL" (ngModelChange)="onOtherFilterChange('mbl', $event, mblOptions)"
                    [nzLoading]="loadingMBL" nzPlaceHolder="MBL(s)" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of mblOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8" style="margin-top: 16px;">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedHBL" (ngModelChange)="onOtherFilterChange('hbl', $event, hblOptions)"
                    [nzLoading]="loadingHBL" nzPlaceHolder="HBL(s)" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of hblOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8" style="margin-top: 16px;">
                <div class="filter-field" style="display: flex; align-items: center; gap: 8px; height: 31px;">
                  <nz-switch [(ngModel)]="inExecution" (ngModelChange)="onInExecutionChange($event)"></nz-switch>
                  <span style="font-size: 13px; white-space: nowrap;">Activos</span>
                </div>
              </nz-col>
            </nz-row>
            } @else if (filterMode === 'inventory-operations') {
            <!-- Inventory Operations Mode Filters -->
            <!-- Inventory Operations Mode Filters -->
            <nz-row [nzGutter]="16">
              <nz-col [nzSpan]="8">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedOrigin"
                    (ngModelChange)="onOtherFilterChange('origin', $event, originOptions)" [nzLoading]="loadingOrigin"
                    nzPlaceHolder="Origen" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of originOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedDestination"
                    (ngModelChange)="onOtherFilterChange('destination', $event, destinationOptions)"
                    [nzLoading]="loadingDestination" nzPlaceHolder="Destino" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of destinationOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedSupplier"
                    (ngModelChange)="onOtherFilterChange('supplier', $event, supplierOptions)"
                    [nzLoading]="loadingSupplier" nzPlaceHolder="Proveedor" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of supplierOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8" style="margin-top: 16px;">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedProduct"
                    (ngModelChange)="onOtherFilterChange('product', $event, productOptions)"
                    [nzLoading]="loadingProduct" nzPlaceHolder="Producto" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of productOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8" style="margin-top: 16px;">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedBatch"
                    (ngModelChange)="onOtherFilterChange('batch', $event, batchOptions)" [nzLoading]="loadingBatch"
                    nzPlaceHolder="Lote" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 32px; max-height: 32px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of batchOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="8" style="margin-top: 16px;">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedSerialNumber"
                    (ngModelChange)="onOtherFilterChange('serialNumber', $event, serialNumberOptions)"
                    [nzLoading]="loadingSerialNumber" nzPlaceHolder="Número de serie" nzMode="multiple"
                    [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of serialNumberOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>
            } @else if (filterMode === 'inventory-stock') {
            <!-- Inventory Stock Mode Filters -->
            <!-- Inventory Stock Mode Filters -->
            <nz-row [nzGutter]="16">
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedProduct"
                    (ngModelChange)="onOtherFilterChange('product', $event, productOptions)"
                    [nzLoading]="loadingProduct" nzPlaceHolder="Producto" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of productOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedLocation"
                    (ngModelChange)="onOtherFilterChange('location', $event, locationOptions)"
                    [nzLoading]="loadingLocation" nzPlaceHolder="Ubicación" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of locationOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>
            } @else if (filterMode === 'temperature') {
            <!-- Temperature Mode Filters -->
            <!-- Temperature Mode Filters -->
            <!-- First row: BESS and MBL -->
            <nz-row [nzGutter]="16">
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedBESS"
                    (ngModelChange)="onOtherFilterChange('bess', $event, bessOptions)" [nzLoading]="loadingBESS"
                    nzPlaceHolder="BESS" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of bessOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedMBL" (ngModelChange)="onOtherFilterChange('mbl', $event, mblOptions)"
                    [nzLoading]="loadingMBL" nzPlaceHolder="MBL" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of mblOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>
            <!-- Second row: Proyecto -->
            <nz-row [nzGutter]="16" style="margin-top: 16px;">
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedProjects"
                    (ngModelChange)="onOtherFilterChange('projects', $event, projectOptions)"
                    [nzLoading]="loadingProjects" nzPlaceHolder="Proyecto" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of projectOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedDestinationTransportRef"
                    (ngModelChange)="onOtherFilterChange('destinationTransportRef', $event, destinationTransportRefOptions)"
                    [nzLoading]="loadingDestinationTransportRef" nzPlaceHolder="Motonave" nzMode="multiple"
                    [nzMaxTagCount]="1"
                    style="width: 100%; height: 31px; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of destinationTransportRefOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>

            <!-- Commented out remaining filters for now -->
            <!--
                <div class="filter-row flex">
                  <div class="filter-field">
                    <nz-select
                      [(ngModel)]="selectedTracker"
                      (ngModelChange)="onOtherFilterChange('tracker', $event)"
                      [nzLoading]="loadingTracker"
                      nzPlaceHolder="Tracker"
                      nzMode="multiple"
                      [nzMaxTagCount]="1"
                      style="width: 162px; height: 32px; max-height: 32px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      <nz-option *ngFor="let option of trackerOptions" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
                    </nz-select>
                  </div>
                  <div class="filter-field">
                    <nz-select
                      [(ngModel)]="selectedLote"
                      (ngModelChange)="onOtherFilterChange('lote', $event)"
                      [nzLoading]="loadingLote"
                      nzPlaceHolder="Lote"
                      nzMode="multiple"
                      [nzMaxTagCount]="1"
                      style="width: 162px; height: 32px; max-height: 32px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      <nz-option *ngFor="let option of loteOptions" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
                    </nz-select>
                  </div>
                  <div class="filter-field">
                    <nz-select
                      [(ngModel)]="selectedSerialNumber"
                      (ngModelChange)="onOtherFilterChange('serialNumber', $event, serialNumberOptions)"
                      [nzLoading]="loadingSerialNumber"
                      nzPlaceHolder="Número de serie"
                      nzMode="multiple"
                      [nzMaxTagCount]="1"
                      style="width: 162px; height: 32px; max-height: 32px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      <nz-option *ngFor="let option of serialNumberOptions" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
                    </nz-select>
                  </div>
                </div>
                -->

            <!-- Commented out temperature range section for now -->
            <!--
                <div class="temperature-section">
                  <div class="temperature-header">
                    <app-icon name="sun-snow" color="#16A34A" [size]="18"></app-icon>
                    <span class="temperature-label">Temperatura</span>
                  </div>
                  <div class="temperature-inputs">
                    <nz-input-group [nzPrefix]="lowPrefix" class="temperature-input-group">
                      <input nz-input
                        type="number"
                        class="temperature-input"
                        [(ngModel)]="temperatureMin"
                        (ngModelChange)="onTemperatureChange()"
                        placeholder="28°"
                      />
                    </nz-input-group>
                    <ng-template #lowPrefix>
                      <app-icon name="thermometer-snowflake" color="#3B82F6" [size]="18"></app-icon>
                    </ng-template>
                    <span class="temperature-separator">hasta</span>
                    <nz-input-group [nzPrefix]="highPrefix" class="temperature-input-group">
                      <input nz-input
                        type="number"
                        class="temperature-input"
                        [(ngModel)]="temperatureMax"
                        (ngModelChange)="onTemperatureChange()"
                        placeholder="48°"
                      />
                    </nz-input-group>
                    <ng-template #highPrefix>
                      <app-icon name="thermometer-sun" color="#EF4444" [size]="16"></app-icon>
                    </ng-template>
                  </div>
                  <div class="temperature-slider">
                    <nz-slider
                      nzRange
                      [nzMin]="0"
                      [nzMax]="100"
                      [ngModel]="[temperatureMin, temperatureMax]"
                      nzTooltipPlacement="bottom"
                      (ngModelChange)="onTemperatureSliderChange($event)"
                    ></nz-slider>
                  </div>
                </div>
                -->
            } @else if (filterMode === 'carbonFootprint') {
            <!-- Carbon Footprint Mode Filters -->
            <!-- Carbon Footprint Mode Filters -->
            <nz-row [nzGutter]="16">
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedProjectCarbon"
                    (ngModelChange)="onOtherFilterChange('projectCarbon', $event, projectCarbonOptions)"
                    [nzLoading]="loadingProjectCarbon" nzPlaceHolder="Proyecto" nzMode="default"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of projectCarbonOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedShippingRef"
                    (ngModelChange)="onOtherFilterChange('shippingRef', $event, shippingRefOptions)"
                    [nzLoading]="loadingShippingRef" nzPlaceHolder="Referencia de envío" nzMode="multiple"
                    [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of shippingRefOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>
            <nz-row [nzGutter]="16" style="margin-top: 16px;">
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedMBLCarbon"
                    (ngModelChange)="onOtherFilterChange('mblCarbon', $event, mblCarbonOptions)"
                    [nzLoading]="loadingMBLCarbon" nzPlaceHolder="MBL" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of mblCarbonOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedContainer"
                    (ngModelChange)="onOtherFilterChange('container', $event, containerOptions)"
                    [nzLoading]="loadingContainer" nzPlaceHolder="Contenedor" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of containerOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>
            } @else if (filterMode === 'operations') {
            <!-- Operations Mode Filters -->
            <!-- Operations Mode Filters -->
            <nz-row [nzGutter]="16">
              <!-- Columna Izquierda -->
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <label class="filter-label">Proyecto</label>
                  <nz-select [(ngModel)]="selectedProject"
                    (ngModelChange)="onOtherFilterChange('operationsProject', $event, operationsProjectOptions)"
                    [nzLoading]="loadingProject" nzPlaceHolder="Proyecto" nzMode="multiple" nzShowSearch
                    [nzFilterOption]="filterOption" [nzMaxTagCount]="1" style="width: 100%;">
                    <nz-option *ngFor="let option of operationsProjectOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <!-- Columna Derecha -->
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <label class="filter-label">MBL</label>
                  <nz-select [(ngModel)]="selectedOperationsMBL"
                    (ngModelChange)="onOtherFilterChange('operationsMBL', $event, operationsMBLOptions)"
                    [nzLoading]="loadingOperationsMBL" nzPlaceHolder="MBL" nzMode="multiple" nzShowSearch
                    [nzFilterOption]="filterOption" [nzMaxTagCount]="1" style="width: 100%;">
                    <nz-option *ngFor="let option of operationsMBLOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>
            <nz-row [nzGutter]="16" style="margin-top: 16px;">
              <!-- Columna Izquierda -->
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <label class="filter-label">Contenedor</label>
                  <nz-select [(ngModel)]="selectedOperationsContainer"
                    (ngModelChange)="onOtherFilterChange('operationsContainer', $event, operationsContainerOptions)"
                    [nzLoading]="loadingOperationsContainer" nzPlaceHolder="Contenedor" nzMode="multiple" nzShowSearch
                    [nzFilterOption]="filterOption" [nzMaxTagCount]="1" style="width: 100%;">
                    <nz-option *ngFor="let option of operationsContainerOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <!-- Columna Derecha -->
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <label class="filter-label">HBL</label>
                  <nz-select [(ngModel)]="selectedOperationsHBL"
                    (ngModelChange)="onOtherFilterChange('operationsHBL', $event, operationsHBLOptions)"
                    [nzLoading]="loadingOperationsHBL" nzPlaceHolder="HBL" nzMode="multiple" nzShowSearch
                    [nzFilterOption]="filterOption" [nzMaxTagCount]="1" style="width: 100%;">
                    <nz-option *ngFor="let option of operationsHBLOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>
            <nz-row [nzGutter]="16" style="margin-top: 16px;">
              <!-- Columna Izquierda -->
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <label class="filter-label">Servicios</label>
                  <nz-select [(ngModel)]="selectedServices"
                    (ngModelChange)="onOtherFilterChange('operationsServices', $event, servicesOptions)"
                    [nzLoading]="loadingServices" nzPlaceHolder="Servicios" nzMode="multiple" nzShowSearch
                    [nzFilterOption]="filterOption" [nzMaxTagCount]="1" style="width: 100%;">
                    <nz-option *ngFor="let option of servicesOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <!-- Columna Derecha vacía para mantener la alineación -->
              <nz-col [nzSpan]="12">
                <div class="filter-field"></div>
              </nz-col>
            </nz-row>
            } @else if (filterMode === 'crm-totals') {
            <!-- CRM Totals Mode Filters -->
            <!-- CRM Totals Mode Filters -->
            <nz-row [nzGutter]="16">
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedCompanies"
                    (ngModelChange)="onOtherFilterChange('companies', $event, companyOptions)"
                    [nzLoading]="loadingCompanies" nzPlaceHolder="Compañías" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 32px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of companyOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedFilterProperty" (ngModelChange)="onFilterPropertyChange($event)"
                    nzPlaceHolder="Etapa" [nzAllowClear]="true"
                    style="width: 100%; max-height: 32px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of filterPropertyOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>

            <!-- Amount Range Section -->
            <div class="amount-range-section">
              <div class="amount-range-header">
                <app-icon name="receipt" color="#16A34A" [size]="18"></app-icon>
                <span class="amount-range-label">Rango de montos</span>
              </div>
              <div class="amount-range-inputs">
                <nz-input-group [nzPrefix]="minPrefix" class="amount-input-group">
                  <input nz-input type="number" class="amount-input" [(ngModel)]="amountMin"
                    (ngModelChange)="onAmountChange()" placeholder="Mínimo" [min]="amountSliderMin"
                    [max]="amountSliderMax" />
                </nz-input-group>
                <span class="amount-separator">hasta</span>
                <nz-input-group [nzPrefix]="maxPrefix" class="amount-input-group">
                  <input nz-input type="number" class="amount-input" [(ngModel)]="amountMax"
                    (ngModelChange)="onAmountChange()" placeholder="Máximo" [min]="amountSliderMin"
                    [max]="amountSliderMax" />
                </nz-input-group>
              </div>
              <ng-template #minPrefix>
                <app-icon name="arrow-up" color="#3B82F6" [size]="18"></app-icon>
              </ng-template>
              <ng-template #maxPrefix>
                <app-icon name="arrow-down" color="#3B82F6" [size]="18"></app-icon>
              </ng-template>
              <!--                  <div class="amount-range-labels">-->
              <!--                    <div class="amount-label-item">-->
              <!--                      <div class="amount-label-icon">-->
              <!--                        <app-icon name="arrow-up" color="#3B82F6" [size]="18"></app-icon>-->
              <!--                        <span class="amount-label-superscript">0</span>-->
              <!--                      </div>-->
              <!--                      <span class="amount-label-value">{{ formatAmount(amountMin) }}</span>-->
              <!--                    </div>-->
              <!--                    <div class="amount-label-item">-->
              <!--                      <div class="amount-label-icon">-->
              <!--                        <app-icon name="arrow-down" color="#EF4444" [size]="18"></app-icon>-->
              <!--                        <span class="amount-label-superscript">0</span>-->
              <!--                      </div>-->
              <!--                      <span class="amount-label-value">{{ formatAmount(amountMax) }}</span>-->
              <!--                    </div>-->
              <!--                  </div>-->
            </div>
            } @else if (filterMode === 'finance') {
            <!-- Finance Mode Filters -->
            <nz-row [nzGutter]="16">
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select class="finance-project-select" [(ngModel)]="selectedProjects"
                    (ngModelChange)="onOtherFilterChange('projects', $event, projectOptions)"
                    [nzLoading]="loadingProjects" nzPlaceHolder="Proyectos" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of projectOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="12">
                <div class="filter-field">
                  <nz-select [(ngModel)]="selectedMargin"
                    (ngModelChange)="onOtherFilterChange('margin', $event, marginOptions)" [nzLoading]="loadingMargin"
                    nzPlaceHolder="Margen"
                    style="width: 100%; max-height: 32px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <nz-option *ngFor="let option of marginOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                  <!--                    <nz-select-->
                  <!--                      [(ngModel)]="selectedCountry"-->
                  <!--                      (ngModelChange)="onOtherFilterChange('country', $event, countryOptions)"-->
                  <!--                      [nzLoading]="loadingCountry"-->
                  <!--                      nzPlaceHolder="País"-->
                  <!--                      nzMode="multiple"-->
                  <!--                      [nzMaxTagCount]="1"-->
                  <!--                      style="width: 100%; max-height: 31px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">-->
                  <!--                      <nz-option *ngFor="let option of countryOptions" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>-->
                  <!--                    </nz-select>-->
                </div>
              </nz-col>
            </nz-row>

            <!-- Amount Range Section -->
            <div class="amount-range-section">
              <div class="amount-range-header">
                <app-icon name="receipt" color="#16A34A" [size]="18"></app-icon>
                <span class="amount-range-label">Rango de montos</span>
              </div>
              <div class="amount-range-inputs">
                <nz-input-group [nzPrefix]="minPrefix" class="amount-input-group">
                  <input nz-input type="number" class="amount-input" [(ngModel)]="amountMin"
                    (ngModelChange)="onAmountChange()" placeholder="Mínimo" [min]="amountSliderMin"
                    [max]="amountSliderMax" />
                </nz-input-group>
                <span class="amount-separator">hasta</span>
                <nz-input-group [nzPrefix]="maxPrefix" class="amount-input-group">
                  <input nz-input type="number" class="amount-input" [(ngModel)]="amountMax"
                    (ngModelChange)="onAmountChange()" placeholder="Máximo" [min]="amountSliderMin"
                    [max]="amountSliderMax" />
                </nz-input-group>
              </div>
              <ng-template #minPrefix>
                <app-icon name="arrow-up" color="#3B82F6" [size]="18"></app-icon>
              </ng-template>
              <ng-template #maxPrefix>
                <app-icon name="arrow-down" color="#3B82F6" [size]="18"></app-icon>
              </ng-template>
            </div>
            } @else {
            <!-- CRM Mode Filters -->
            <nz-row [nzGutter]="16">
              <nz-col [nzSpan]="12">
                <div class="filter-field" *ngIf="additionalFilterTypes.includes('companies')">
                  <label class="filter-label">Compañía</label>
                  <nz-select [(ngModel)]="selectedCompanies"
                    (ngModelChange)="onOtherFilterChange('companies', $event, companyOptions)"
                    [nzLoading]="loadingCompanies" nzPlaceHolder="Compañía(s)" nzMode="multiple" [nzMaxTagCount]="1"
                    style="width: 100%;">
                    <nz-option *ngFor="let option of companyOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="12">
                <div class="filter-field" *ngIf="additionalFilterTypes.includes('users')">
                  <label class="filter-label">Usuario</label>
                  <nz-select [(ngModel)]="selectedUsers"
                    (ngModelChange)="onOtherFilterChange('users', $event, userOptions)" [nzLoading]="loadingUsers"
                    nzPlaceHolder="Usuario(s)" nzMode="multiple" [nzMaxTagCount]="1" style="width: 100%;">
                    <nz-option *ngFor="let option of userOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
            </nz-row>
            <nz-row [nzGutter]="16" style="margin-top: 16px;">
              <nz-col [nzSpan]="12">
                <div class="filter-field" *ngIf="additionalFilterTypes.includes('clients')">
                  <label class="filter-label">Cliente</label>
                  <nz-select [(ngModel)]="selectedClients"
                    (ngModelChange)="onOtherFilterChange('clients', $event, clientOptions)" [nzLoading]="loadingClients"
                    nzPlaceHolder="Cliente(s)" nzMode="multiple" [nzMaxTagCount]="1" style="width: 100%;">
                    <nz-option *ngFor="let option of clientOptions" [nzValue]="option.value"
                      [nzLabel]="option.label"></nz-option>
                  </nz-select>
                </div>
              </nz-col>
              <nz-col [nzSpan]="12">
                <div class="filter-field crm-budget-field" *ngIf="filterMode === 'crm'">
                  <nz-segmented [nzOptions]="withoutBudgetOptions" [ngModel]="withoutBudget ? 0 : 1"
                    (ngModelChange)="onWithoutBudgetSegmentedChange($event)" nzBlock>
                  </nz-segmented>
                </div>
              </nz-col>
            </nz-row>
            }
          </div>
        </nz-card>
        <ng-template #additionalFiltersTitleTpl>
          <div class="title-with-icon">
            <app-icon name="filter" size="base"></app-icon>
            <span>Filtros adicionales</span>
          </div>
        </ng-template>
      </nz-col>
    </nz-row>
  </div>
  }
</div>